import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
};

const postConversion = createSlice({
  name: 'postConversion',
  initialState,
  reducers: {
    convert: state => {
      state.isLoading = true;
    },
    convertSuccess: state => {
      state.isLoading = false;
    },
    convertFailure: state => {
      state.isLoading = false;
    },
    resetConversion: state => {
      state.isLoading = false;
    },
  },
});

export const { convert, convertSuccess, convertFailure, resetConversion } = postConversion.actions;
export default postConversion.reducer;
